enum UpdateBatchProgressAction {
    ADD = "ADD",
    REMOVE = "REMOVE"
}

export default UpdateBatchProgressAction;